import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast, ToastContainer } from "react-toastify";
import axios from "axios";
import { BASE_URL } from "../../config.json";

const initialValues = {
  password: "",
  repeatPassword: "",
};

const onSubmit = (values) => {
  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get("token");

  axios
    .post(`${BASE_URL}/user/password_reset/confirm/`, {
      token: token,
      password: values.password,
    })
    .then((res) => {
      console.log(res, "res");
        toast.success("Password changed successfully");

    }).catch((err) => {
      const errors = err.response?.data;

      let errorMsg = "Something went wrong.";
      if (errors?.password) {
        errorMsg = errors.password.join(", "); 
      } else if (errors?.detail) {
        errorMsg = errors.detail; 
      }

      toast.error(errorMsg);
    });
};

const validationSchema = Yup.object().shape({
  password: Yup.string()
    .required("Password is required")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/,
      "Use at least 8 characters\n- One uppercase, one lowercase, and one number"
    ),
  repeatPassword: Yup.string()
    .required("Required")
    .oneOf([Yup.ref("password"), null], "Passwords must match"),
});

const ChangePass = () => {
  const [passwordShown, setPasswordShown] = useState(false);
  const [confirmPasswordShown, setConfirmPasswordShown] = useState(false);

  const formik = useFormik({
    initialValues,
    onSubmit,
    validationSchema,
  });

  // Toggle functions
  const togglePassword = () => setPasswordShown(!passwordShown);
  const toggleConfirmPassword = () =>
    setConfirmPasswordShown(!confirmPasswordShown);

  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <ToastContainer />
        <div className="c-pass">
          <h1 className="c-pass--title text-jost-sb-50-wt">Change Password</h1>

          <div className="c-pass__wrap">
            <div className="c-pass__box">
              <h2 className="c-pass__box--txt text-jost-sb-22">
                Create a new password
              </h2>
              <p className="c-pass__box--para text-ops-rg-16">
                Thank you message. Lorem ipsum dolor sit amet consectetur adipisicing elit. E
                veniet perspiciatis quisquam reprehenderit dolores, iste animi eum ull
                am, quibusdam veniam corrupti dolor et omnis earum amet, id nam illum aperiam vero?\
              </p>

              <div className="c-pass__box__form">
                {/* Password Field */}
                <div className="input-container">
                  <input
                    className="form__input-md"
                    type={passwordShown ? "text" : "password"}
                    placeholder="Create a Password"
                    name="password"
                    {...formik.getFieldProps("password")}
                  />
                  <span className="toggle_eye" onClick={togglePassword}>
                    {passwordShown ? (
                      <img
                        src={require("../../assets/images/password_img/show.svg")
                          .default}
                        alt="Show Password"
                      />
                    ) : (
                      <img
                        src={require("../../assets/images/password_img/hide.svg")
                          .default}
                        alt="Hide Password"
                      />
                    )}
                  </span>
                  {formik.touched.password && formik.errors.password ? (
                    <div className="errors">{formik.errors.password}</div>
                  ) : null}
                </div>

                {/* Confirm Password Field */}
                <div className="input-container">
                  <input
                    className="form__input-md"
                    type={confirmPasswordShown ? "text" : "password"}
                    placeholder="Confirm New Password"
                    name="repeatPassword"
                    {...formik.getFieldProps("repeatPassword")}
                  />
                  <span className="toggle_eye" onClick={toggleConfirmPassword}>
                    {confirmPasswordShown ? (
                      <img
                        src={require("../../assets/images/password_img/show.svg")
                          .default}
                        alt="Show Password"
                      />
                    ) : (
                      <img
                        src={require("../../assets/images/password_img/hide.svg")
                          .default}
                        alt="Hide Password"
                      />
                    )}
                  </span>
                  {formik.touched.repeatPassword &&
                  formik.errors.repeatPassword ? (
                    <div className="errors">{formik.errors.repeatPassword}</div>
                  ) : null}
                </div>
              </div>

              <div className="c-pass__box--links">
                <button type="submit" className="res-btn-primary">
                  Reset Password
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default ChangePass;
